
































import moment from "moment";
import DateInput from "../../core/Forms/DateInput.vue";

export default {
    name: "AbsencesTableHeader",
    components: { DateInput },
    props: {
        employeId: Number,
        filters: Object,
    },
    data() {
        return {
            dateRange: {
                start: moment().startOf("year").format("YYYY-MM-DD"),
                end: moment().endOf("year").format("YYYY-MM-DD"),
            },
            absences: [],
            datepickerAttributes: [
                {
                    key: "today",
                    dot: true,
                    dates: new Date(),
                },
            ],
        };
    },
    watch: {
        dateRange: {
            immediate: true,
            deep: true,
            handler: function (newVal, oldVal) {
                let startDate = moment(this.dateRange.start);
                let endDate = moment(this.dateRange.end);
                this.filters.startDate = startDate.format("YYYY-MM-DD");
                this.filters.endDate = endDate.format("YYYY-MM-DD");
            },
        },
    },
};
